import { SortAscendingIcon, SortDescendingIcon } from '~/icons';

export const MuiDataGrid = {
  defaultProps: {
    rowHeight: 58,
    slots: {
      columnSortedAscendingIcon: SortAscendingIcon,
      columnSortedDescendingIcon: SortDescendingIcon,
    },
    slotProps: {
      cell: {
        title: undefined,
      },
      loadingOverlay: {
        variant: 'linear-progress',
        noRowsVariant: 'circular-progress',
      },
    },
    localeText: {
      // Hide 'Sort' tooltip
      columnHeaderSortIconLabel: '',
    },
    disableColumnSelector: true,
    disableColumnMenu: true,
    disableColumnResize: true,
    disableRowSelectionOnClick: true,
  },
  styleOverrides: {
    root: {
      '&.MuiDataGrid-root': {
        border: 'none',

        '& .MuiCircularProgress-root': {
          color: '#1010EB',
        },
      },
      '& .MuiDataGrid-main': {
        height: '100%',
      },
      '& .MuiDataGrid-virtualScroller': {
        overflowY: 'auto',
      },
      flexDirection: 'column-reverse',

      '& .MuiDataGrid-cell': {
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        overflow: 'visible',
        lineHeight: '2rem',
        paddingBlock: '2rem',
        fontSize: '1.6rem',
        display: 'flex',
        alignItems: 'center',
        padding: '4px',

        '&:focus': {
          outline: 'none !important',
        },
        '&:focus-within': {
          outline: 'none !important',
        },
      },
      '& .MuiDataGrid-columnHeaderTitleContainerContent': {
        '& span': {
          width: 'max-content ',
        },
      },
      '& .MuiDataGrid-columnHeader': {
        padding: '2px',

        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 600,
          fontSize: '1.7rem',
        },
        '&:focus': {
          outline: 'none !important',
        },
        '&:focus-within': {
          outline: 'none !important',
        },
      },
      '& .MuiDataGrid-row:hover': {
        backgroundColor: '#140F4B14',
      },
      '& .MuiDataGrid-footerContainer': { borderTop: 'none' },
    },
  },
};
